export default "__VITE_ASSET__DcEsDWTm__"